import React from "react";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AxiosService from "../../utils/AxiosService";

import Card from "../../components/Card/Card";
import { toast } from "react-toastify";
import LocalStorageService from "../../utils/auth_service/AuthServiceStorage";
import { APPLICATION_NAME } from "../../utils/Constant";
import { isValidToken } from "../../utils/auth_service/AuthServiceHelper";

const projectName = ["Project 1", "Project 2", "Project 3"];

const SelectProject = () => {
  const apiService = new AxiosService();
  const authDetails = LocalStorageService.getAuthDetails();
  const [project, setProject] = useState("");
  const [projectName, setProjectName] = useState("");
  const [projects, setProjects] = useState([]);
  const [isConfirm, setIsConfirm] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    apiService
      .getProjectList()
      .then((response) => {
        setProjects(response.data.data);
      })
      .catch((error) => {
        if (!isValidToken(error.response.data.message)) {
          toast.error("Please Login to Continue", { autoClose: 2000 });
          navigate(`/${APPLICATION_NAME}/login`);
        } else {
          toast.error(error.response.data.message, { autoClose: 2000 });
        }
      });
  }, []);

  const onChangeHandler = (event) => {
    const value = event.target.value;
    const text = event.target.options[event.target.selectedIndex].text;
    setProject(value);
    setProjectName(text);
  };

  const onSubmitHandler = (event) => {
    event.preventDefault();
    if (project !== "" && projectName !== "") {
      LocalStorageService.setProjectDetails(
        JSON.stringify({ projectId: project, projectName: projectName })
      );
      navigate(`/${APPLICATION_NAME}/home`);
    } else {
      toast.error("Please Select Project");
    }
  };

  const handleBackToSignIn = () => {
    navigate(`/${APPLICATION_NAME}/login`);
  };

  return (
    <Card>
      <h5 className=" text-start">Select Project</h5>
      <p className=" text-start text-muted">
        Select the project you want to manage the manuscript for.
      </p>
      <form onSubmit={onSubmitHandler}>
        <div className="mb-5">
          <label htmlFor="projectSelect" className="form-label text-muted">
            Select project
          </label>
          <select
            className="form-select"
            id="projectSelect"
            onChange={onChangeHandler}
            value={project}
          >
            <option value={""}> select project</option>
            {projects &&
              projects.map((project) => (
                <option
                  value={project.projectId}
                  className="bg-gray-100 hover:bg-gray-200"
                  key={project.projectId}
                >
                  {project.projectName}
                </option>
              ))}
          </select>
        </div>
        <div className="d-flex justify-content-between">
          <button
            type="button"
            className="btn btn-outline-primary"
            onClick={handleBackToSignIn}
          >
            Back to Sign in
          </button>
          <button type="submit" className="btn btn-primary">
            Confirm
          </button>
        </div>
      </form>
    </Card>
  );
};

export default SelectProject;
